import { SelectChangeEvent } from '@mui/material/Select'
import React, { useState } from 'react'
import LanguageCurrencyDropdown, { CountryOption, LanguageCurrencyDropdownProps } from './LanguageCurrencyDropdown'
import { getCookie, setCookie } from '@/src/utils/browser'

const getCountryOptions = (t: (key: string) => string): CountryOption[] => [
    { code: 'FOEG', label: t('countries.egypt'), domain: 'b2e.flyin.com', qaDomain: 'b2e.flyin.com',currency : 'EGP' },
    { code: 'FOAE', label: t('countries.uae'), domain: 'b2e.flyin.com', qaDomain: 'b2e.flyin.com', currency : 'AED' },
    { code: 'FOSA', label: t('countries.global'), domain: 'b2e.flyin.com', qaDomain: 'b2e.flyin.com', currency : 'SAR' }
]

const detectCurrentCountry = (hostname: string, countryOptions: CountryOption[], isQA: boolean): CountryOption => {
    // Find the country that matches the current hostname
    const matchedCountry = countryOptions.find(country => {
        const targetDomain = isQA ? country.qaDomain : country.domain
        return hostname.includes(targetDomain)
    })
    // Return matched country or global options
    return matchedCountry || countryOptions[2]
}
interface LanguageCurrencyDropdownLogicProps {
    selectedLanguage: LanguageCurrencyDropdownProps['selectedLanguage']
    selectedCurrency: LanguageCurrencyDropdownProps['selectedCurrency']
    languageOptions: LanguageCurrencyDropdownProps['languageOptions']
    currencyOptions: LanguageCurrencyDropdownProps['currencyOptions']
    onLanguageSelect: LanguageCurrencyDropdownProps['onLanguageSelect']
    onCurrencySelect: LanguageCurrencyDropdownProps['onCurrencySelect']
    t: LanguageCurrencyDropdownProps['t']
    tCurrency: LanguageCurrencyDropdownProps['tCurrency']
    isOffersPage?: boolean
    isResultsPage?: boolean
}

const LanguageCurrencyDropdownLogic: React.FC<LanguageCurrencyDropdownLogicProps> = props => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [countrySelectOpen, setCountrySelectOpen] = useState(false)
    const open = Boolean(anchorEl)
    const isQA = typeof window !== 'undefined' && window.location.hostname.includes('me')
    const countryOptions = getCountryOptions(props.t)

    const getCurrentCountry = (): CountryOption => {
        if (typeof window === 'undefined') return countryOptions[0]
        const countryCode = getCookie('selected_country')
        return countryOptions.find(c => c.code === countryCode) || countryOptions[2]
    }

    const [selectedCountry, setSelectedCountry] = useState<CountryOption>(() => {
        const country = getCurrentCountry()
        setCookie('selected_country', country.code)
        return country || countryOptions[1]
    })

    const handleCountryChange = (event: SelectChangeEvent) => {
        const countryCode = event.target.value
        const newCountry = countryOptions.find(c => c.code === countryCode) || countryOptions[0]

        if (newCountry.code === selectedCountry.code) return
        setCookie('selected_country', newCountry.code)
        const currencyObject = props.currencyOptions.find(c => c.code === newCountry.currency)
        if (currencyObject) props.onCurrencySelect(currencyObject)
        setSelectedCountry(newCountry)
    }

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleCountrySelectOpen = () => setCountrySelectOpen(true)
    const handleCountrySelectClose = () => setCountrySelectOpen(false)

    return (
        <LanguageCurrencyDropdown
            {...props}
            selectedCountry={selectedCountry}
            countryOptions={countryOptions}
            countrySelectOpen={countrySelectOpen}
            onCountrySelectOpen={handleCountrySelectOpen}
            onCountrySelectClose={handleCountrySelectClose}
            onCountryChange={handleCountryChange}
            onCountrySelect={() => {}}
            open={open}
            anchorEl={anchorEl}
            onOpen={handleOpen}
            onClose={handleClose}
            isOffersPage={props.isOffersPage}
            isResultsPage={props.isResultsPage}
        />
    )
}

export default LanguageCurrencyDropdownLogic
